import React from 'react';
import { cn } from './cn';

export type BadgeTone = 'neutral' | 'forest' | 'trigo' | 'success' | 'warning' | 'danger' | 'info';

const tones: Record<BadgeTone, string> = {
  neutral: 'bg-paper-2 text-sage border-hairline',
  forest: 'bg-forest/10 text-forest border-forest/15',
  trigo: 'bg-trigo/15 text-ink border-trigo/40',
  success: 'bg-success/10 text-success border-success/20',
  warning: 'bg-warning/10 text-warning border-warning/20',
  danger: 'bg-danger/10 text-danger border-danger/20',
  info: 'bg-info/10 text-info border-info/20',
};

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

/**
 * Pill semántico para estados y etiquetas (estado del animal, stock bajo, etc.).
 * Reemplaza los badges arcoíris por una paleta coherente y no saturada.
 */
export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ tone = 'neutral', className, children, ...rest }, ref) => (
    <span
      ref={ref}
      className={cn(
        'inline-flex items-center gap-1 rounded border px-2 py-0.5 text-xs font-medium leading-5 whitespace-nowrap',
        tones[tone],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  ),
);
Badge.displayName = 'Badge';

export default Badge;
